import dayjs from 'dayjs';
import type { ReturnTypeFromUseAcademicNamespace } from '../hooks';

export function capDateToNamespace(
  date: dayjs.Dayjs | string,
  activeAcademicNamespace: ReturnTypeFromUseAcademicNamespace['activeAcademicNamespace'],
): dayjs.Dayjs {
  const checkedDate = typeof date === 'string' ? dayjs(date) : date;

  if (
    !activeAcademicNamespace?.startDate ||
    !activeAcademicNamespace?.endDate
  ) {
    return checkedDate;
  }

  const start = dayjs(activeAcademicNamespace.startDate);
  const end = dayjs(activeAcademicNamespace.endDate);

  if (checkedDate.isBefore(start)) {
    return start;
  }

  if (checkedDate.isAfter(end)) {
    return end;
  }

  return checkedDate;
}
